import React, { useMemo, useState, memo,useEffect } from "react";
import { Chart } from "primereact/chart";
import { t } from "i18next";
import EventEmitter, { Events } from "../../services/eventemitter";

type AgentChat = {
    chatsUserWise: number;
    userName: string;
};

type TotalAgentsChatProps = {
    data?: AgentChat[],
    heading: string
};

const TotalAgentsChat: React.FC<TotalAgentsChatProps> = memo((props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [refreshState, setRefreshState] = useState<any>(new Date())

    useEffect(() => {
        EventEmitter.on(Events.forceFullyChangeLanguage, forceFullyChangeLanguage);
    }, [])
    
    const forceFullyChangeLanguage = () => {
        setRefreshState(new Date()?.getTime())
    }

    const { userChats, userNames } = useMemo(() => {
        setIsLoading(true);

        const chatArray: number[] = [];
        const usersArray: string[] = [];

        props?.data?.forEach((element) => {
            if (element.chatsUserWise !== 0) {
                chatArray.push(Math.round(element.chatsUserWise));
                usersArray.push(element.userName);
            }
        });

        setIsLoading(false);

        return {
            userChats: chatArray.reverse(),
            userNames: usersArray.reverse()
        };
    }, [props?.data]);

    const isEmpty = userChats.length === 0 && userNames.length === 0;

    const chartData = useMemo(() => {
        return {
            labels: userNames,
            datasets: [
                {
                    data: userChats,
                    hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
                    backgroundColor: [
                        "#FF6384",
                        "#36A2EB",
                        "#FFCE56",
                        "#008080",
                        "#800080",
                        "#0000FF",
                        "#808000",
                        "#800000",
                        "#808080",
                        "#C0C0C0",
                        "#FF7F50",
                        "#9FE2BF",
                        "#40E0D0",
                        "#FF2A00",
                        "#FF5500",
                        "#FF8000",
                        "#FFAA00",
                        "#FFD400",
                        "#FFFF00",
                        "#D4FF00",
                        "#AAFF00",
                        "#40e0d0",
                        "#b17eb1",
                        "#f190c1",
                        "#ceaece",
                        "#b2f7f9",
                        "#999999",
                        "#94e851",
                        "#002fa7",
                        "#c5f5f0",
                        "#bb88ff",
                        "#ff0000",
                        "#2b5540",
                        "#88d4c3",
                        "#a91e69",
                    ],
                },
            ],
        };
    }, [userChats, userNames]);

    const lightOptions = {
        legend: {
            labels: {
                fontColor: "#495057",
            },
        },
    };

    const emptyData = useMemo(() => {
        return {
            labels: ["empty"],
            datasets: [
                {
                    data: [1],
                    backgroundColor: ["#808080"],
                    hoverBackgroundColor: ["#808080"],
                },
            ],
        };
    }, []);

    return (
        <>
            {!isLoading && (
                <div className="card">
                    <h6>{props.heading}</h6>
                    <Chart type="pie" data={isEmpty ? emptyData : chartData} options={lightOptions} style={{ marginLeft: "25%", position: "relative", width: "50%" }} />
                </div>
            )}
        </>
    );
});

export default TotalAgentsChat;
